import { BLOCK_CLASSES as e } from "../../constants.js";
import { defineAttrs as t } from "../../utils/typed-attrs.js";
import { stylable as n } from "../decorators/stylable.js";
import "../decorators.js";
var r = n({
	inline: !1,
	content: "(block | list)*",
	group: "block",
	selectable: !1,
	attrs: t({ type: { default: "callout" } }),
	parseDOM: [{ tag: `.${e.callout}` }],
	toDOM(t) {
		return [
			"div",
			{
				class: `${e.callout}`,
				"data-insertable": "true"
			},
			0
		];
	}
});
//#endregion
export { r as calloutSpec };
